class HtmlValidationHelper {
  public static fixPipeInGoogleapisLinks = (): void => {
    const links: HTMLElement[] = Array.from(document.querySelectorAll("link"));

    links.forEach((link: HTMLElement) => {
      const href = link.getAttribute("href");

      if (href != null && href.includes("googleapis") === true && href.includes("|") === true) {
        const newHref: string = href.replaceAll("|", "%7C");

        link.setAttribute("href", newHref);
      }
    })
  }

  public static fixMetaCharsetPlace = (): void => {
    const meta = document.querySelector("meta[charset]");

    if (meta != null) {
      const parentElement = meta.parentElement;

      parentElement.removeChild(meta);
      parentElement.prepend(meta);
    }
  }

  public static deleteNotAllowedAttributes = (rootElement = null) => {
    HtmlValidationHelper.deleteAttributesFromElements("input", ["autocorrect"], rootElement);
    HtmlValidationHelper.deleteAttributesFromElements("div", ["direction"], rootElement);
    HtmlValidationHelper.deleteAttributesFromElements("select", ["placeholder"], rootElement);
  }

  private static deleteAttributesFromElements = (elementTagName: string, attributes: string[], rootElement = null): void => {
    const root = rootElement == null ? document : rootElement;
    const elements = Array.from(root.querySelectorAll(elementTagName));

    elements.forEach((element) => {
      attributes.forEach((attribute) => {
        if (element.getAttribute(attribute) != null) {
          element.removeAttribute(attribute);
        }
      })
    })
  }
}

export default HtmlValidationHelper;
